import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {cdnResize} from '../services/utils';
import ReviewStars from './Review-stars';
import PricingAppBox from './Pricing-app-box';
import AddToSiteButton from './Add-to-site-button';
import {openAppInModal, addAppClientData, openEditorApp} from '../services/app-flow';
import {FormattedMessage} from 'react-intl';
import {isOpenInEditorVisible} from '../services/app-type-detector';
import {getIfAppIsInstalledPromise} from '../services/wrapped-app-market-sdk';
import {execBI} from '../services/bi-events-manager';
import injectMain from '../services/inject-main';
import {isExperiment} from '../config';
import ALink from './ALink';

const handleOpenInEditor = (app, biPosition = 0) => {
  return ev => {
    ev.preventDefault();
    openEditorApp(app, biPosition);
  };
};

class AppBoxWide extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenApp = this.handleOpenApp.bind(this);
  }

  handleOpenApp(app, biPosition = 0) {
    return ev => {
      if (!isExperiment('specs.market.AppPageInsideMarket', this.props.experiments) && this.props.market !== 'standalone') {
        ev.preventDefault();
        openAppInModal(app.slug);
      }
      execBI('APP_MODAL_OPEN_CLICK', {app, biPosition});
    };
  }

  componentDidMount() {
    getIfAppIsInstalledPromise({appDefinitionId: this.props.app.appDefinitionId, includingDemoMode: true})
      .then(isInstalled => this.setState({app: addAppClientData(this.props.app, isInstalled), loaded: true}))
      .catch(() => this.setState({app: addAppClientData(this.props.app, false), loaded: true}));
  }

  render() {
    const state = this.state || {};
    const app = state.app || this.props.app;
    const reviews = this.props.reviews[app.appDefinitionId];

    return (
      <div className={classNames('app-box-wide', {'app-box-wide-installed': app.isInstalled, 'app-box-loading': !state.loaded})}>

        <div className="app-box-wide-buttons">
          <div className="app-box-wide-btn secondary">
            {isOpenInEditorVisible(app) ?
              <div className="application-action app-action-toggle">
                <a href="#" className="button-secondary" onClick={handleOpenInEditor(app, this.props.biPosition)}><FormattedMessage id="application.action.open"/></a>
              </div> : ''}
          </div>

          <div className="app-box-wide-btn">
            <div className="circle-loader circle-loader-smaller"></div>
            <div className="app-action-toggle">
              <AddToSiteButton app={app} biPosition={this.props.biPosition} primaryStyle/>
            </div>
            <PricingAppBox app={app}/>
          </div>
        </div>

        <ALink className="app-box-wide-link" to={`/${app.slug}/overview`} onClick={this.handleOpenApp(app, this.props.biPosition)}>
          <div className="app-box-wide-image">
            <img
              className="app-box-wide-image-tag"
              width="60"
              height="60"
              src={cdnResize(app.roundIcon || app.appIcon, 60, 60)}
              alt={`${app.name} by ${app.by} || WIX App Market`}
              />
          </div>

          <h3 className="application-title">
            {app.name}
            <span className="made-by">
              <FormattedMessage id="application.byAppMarket20" values={{company: app.by}}/>
            </span>
          </h3>

          <div className="application-desc">
            <p className="application-description application-description-limit" dangerouslySetInnerHTML={{__html: app.teaser}}></p>
          </div>

          {app.isInstalled ?
            <div className="application-status-circle typography_t3_1">
              <span className="application-status-installed-ico"></span>
              <div className="application-status-installed"><FormattedMessage id="application.status.installed"/></div>
            </div> : null}

          {!app.isInstalled ?
            <div className="stats-app-box">
              <ReviewStars reviews={reviews}/>
            </div> : null }
        </ALink>

      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    reviews: PropTypes.object,
    biPosition: PropTypes.number,
    market: PropTypes.string,
    experiments: PropTypes.object,
  }
}

export default injectMain(AppBoxWide);



// WEBPACK FOOTER //
// ./components/App-box-wide.js